module.exports = __webpack_public_path__ + "img/益视说明书_01.7263ba8a.png";